import HistoricMailsModalView from "../common/historicMails.html";
import SearchStaffModalView from "./searchStaffModal.html";
import AddNewStaffModalView from "./addNewStaffModal.html";

import _ from 'lodash';


angular.module("events")
    .controller("EventsStaffListCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', 'notificationService', 'generateDocumentService', '$stateParams', '$state', '$http', '$window', 'uiGridConstants', 'eventService', 'logService',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, notificationService, generateDocumentService, $stateParams, $state, $http, $window, uiGridConstants, eventService, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_STAFF_WRITE");
            $scope.allowReadUser = LoginService.permissionExist("USERS_READ");
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }
            $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.staff.staff');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.staff.staff') }
            ];
            $scope.classSize = "col-lg-12 col-md-12";

            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null
            }
            function isDefinedAndNotNullOrEmpty(val) {
                return angular.isDefined(val) && val !== null && val !== ""
            }

            $scope.event = event;
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                { title: $filter('translate')('events.staff.staff') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.staff.staff');

            $scope.ConfirmationStatusOptions = [{ value: 'pending', label: $filter('translate')('events.staff.pending') },
                { value: 'confirmed', label: $filter('translate')('events.staff.confirmed') }];

            $scope.is_template = $stateParams.is_template === 'true';
            if (!$scope.is_template) { //No es template
                $scope.gridOptionEventStaff = {
                    pdfTitle: $filter('translate')('events.staff.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    //gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 50, 100],
                    paginationPageSize: 20,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                      {
                          name: 'puesto', field: 'FK_events_staff_staff.FK_staff_staff_positions.name', displayName: $filter('translate')('staff.staff_position'), enableFiltering: true, enableHiding: false,
                          cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'name', field: 'FK_events_staff_staff.fullname', displayName: $filter('translate')('events.staff.name'), enableFiltering: true, enableHiding: false,
                          cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'is_external', field: 'FK_events_staff_staff.is_external', displayName: $filter('translate')('events.staff.is_external'),
                          filter: gridService.yesNoFilter('FK_events_staff_staff.is_external'), width: 100, enableFiltering: true,
                          cellTemplate: gridService.yesNoTemplate('FK_events_staff_staff.is_external')
                      },
                      { name: 'provider_name', field: 'FK_events_staff_staff.provider_name', displayName: $filter('translate')('events.staff.provider_name'), enableFiltering: true },
                      {
                          name: ' ', width: 50, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false,
                          cellTemplate: "<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class=\"ui-grid-cell-contents pull-right\">" +
                              "<a ng-if=\"row.entity.totalNotifications > 0\" class=\"aColorGreen\" ng-click=\"grid.appScope.EventStaffHistoricMail(row.entity.id, row.entity.FK_events_staff_staff.email);\"><i class=\"fa fa-envelope\"></i></a>" +                             
                              "<a class=\"aColorYellow  margin-left-10\" ng-click=\"grid.appScope.deleteDialog(row.entity.id,row.entity.FK_events_staff_staff.name,row.entity.FK_events_staff_staff.surname);\"  ng-if=\"grid.appScope.allowWrite\"><i class=\"fa fa-remove\"></i></a>" +
                              "</div>"
                      },
                    ],
                    getData: function (options) {
                        options.event_id = $stateParams.id;
                        return Restangular.all('eventsStaff').getList(options);
                    }
                };
            } else { //Es template
                $scope.gridOptionEventStaff = {
                    pdfTitle: $filter('translate')('events.staff.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    //gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 50, 100],
                    paginationPageSize: 20,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                      {
                          name: 'puesto', field: 'FK_events_staff_staff.FK_staff_staff_positions.name', displayName: $filter('translate')('staff.staff_position'), enableFiltering: true, enableHiding: false,
                          cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'name', field: 'FK_events_staff_staff.name', displayName: $filter('translate')('events.staff.name'), enableFiltering: true, enableHiding: false,
                          cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'surname', field: 'FK_events_staff_staff.surname', displayName: $filter('translate')('events.staff.surname'), enableFiltering: true,
                          cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'lastname', field: 'FK_events_staff_staff.lastname', displayName: $filter('translate')('events.staff.lastname'), enableFiltering: true,
                          cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'is_external', field: 'FK_events_staff_staff.is_external', displayName: $filter('translate')('events.staff.is_external'),
                          filter: gridService.yesNoFilter('FK_events_staff_staff.is_external'), width: 100, enableFiltering: true,
                          cellTemplate: gridService.yesNoTemplate('FK_events_staff_staff.is_external')
                      },
                      { name: 'provider_name', field: 'FK_events_staff_staff.provider_name', displayName: $filter('translate')('events.staff.provider_name'), enableFiltering: true },
                      {
                          name: ' ', width: 50, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false,
                          cellTemplate: "<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class=\"ui-grid-cell-contents pull-right\">" +
                              "<a class=\"aColorYellow margin-left-10\" ng-click=\"grid.appScope.EventStaffHistoricMail(row.entity.id, row.entity.FK_events_staff_staff.email);\"><i class=\"fa fa-envelope-o\"></i></a>" +
                              "<a class=\"aColorYellow  margin-left-10\" ng-click=\"grid.appScope.deleteDialog(row.entity.id,row.entity.FK_events_staff_staff.name,row.entity.FK_events_staff_staff.surname);\"><i class=\"fa fa-remove\"></i></a>" +
                              "</div>"
                      },
                    ],
                    getData: function (options) {
                        options.event_id = $stateParams.id;
                        return Restangular.all('eventsStaff').getList(options);
                    }
                };
            }

            $scope.editEventStaff = function (id) {
                Restangular.one('EventsStaff', id).get().then(function (eventStaff) {
                    $scope.eventStaff = eventStaff;
                    if ($scope.eventStaff.date_from != null)
                        $scope.eventStaff.date_from = new Date($scope.eventStaff.date_from);
                    if ($scope.eventStaff.date_to != null)
                        $scope.eventStaff.date_to = new Date($scope.eventStaff.date_to);
                    Restangular.all('BudgetGroups').getList().then(function (budgetGroups) {
                        $scope.selectBudgetGroups = budgetGroups;
                        var budgetGroupNull = {
                            id: null,
                            name: $filter('translate')('events.staff.no_budget_group')
                        }
                        $scope.selectBudgetGroups.unshift(budgetGroupNull);

                    });
                });

                $scope.classSize = "col-lg-8 col-md-8";
                if ($window.pageYOffset > 200 && $rootScope.sizeLg) {
                    $scope.styleMargin = $window.pageYOffset - 100;
                }
            }
            $scope.EventStaffHistoricMail = function (id, mail) {
                let options: any = {}
                options.module = "staff/notify";
                options.code = id + "";
                options.event_id = event.id;
                options.to = mail;

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: HistoricMailsModalView,
                    size: "lg",
                    controller: "historicMailsModalCtrl",
                    backdrop: 'static',

                    keyboard: false,
                    resolve: {
                        options: function () {
                            return options;
                        },
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                }, function () {
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

            /*
             * Si lleva el parámetro abro el elemento
             */
            if (angular.isDefined($stateParams.staffId) && $stateParams.staffId != null && $stateParams.staffId != "")
                $scope.editEventStaff($stateParams.staffId)

            $scope.closeStaffInfo = function () {
                $scope.classSize = "col-lg-12 col-md-12";
                $scope.eventStaff = null;
            }

            $scope.saveStaffInfo = function () {
                $scope.eventStaff.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events.staff.edit_success'));
                        $scope.classSize = "col-lg-12 col-md-12";
                        $scope.eventStaff = null;
                        if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                        $scope.gridOptionEventStaff.gridApi.core.raise.itemChanged($scope);
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            };

            $scope.deleteDialog = function (id, name, surname) {
                $scope.id = id;
                let allName = name;
                if (isDefinedAndNotNull(surname))
                    allName += " " + surname;
                modalService.confirm({
                    title: $filter('translate')('events.staff.button_delete'),
                    message: $filter('translate')('events.staff.delete_message') + " " + allName + "?",
                    onAccept: function () {
                        let send_notifications = false;
                        if (angular.isDefined($scope.eventStaff) && $scope.eventStaff != null && $scope.eventStaff.send_notifications != null) {
                            send_notifications = $scope.eventStaff.send_notifications;
                        }
                        Restangular.one('EventsStaff', id).remove({ send_notifications: send_notifications }).then(function () {
                            $scope.gridOptionEventStaff.gridApi.core.raise.itemChanged($scope);
                            toastr.success($filter('translate')('events.staff.delete_success'));
                            $scope.closeStaffInfo();
                            if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                        });
                    }
                });

            };

            $scope.searchMasiveDialog = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchStaffModalView,
                    size: "lg",
                    controller: "SearchStaffModalCtrl"
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                    $scope.gridOptionEventStaff.gridApi.core.raise.itemChanged($scope);
                    if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                    if (!$scope.$$phase) $scope.$apply();

                }, function () {
                    if (!$scope.$$phase) $scope.$apply();
                });

            }; //addPersonsPositionDialog


            /***********************************
             *** Enviar correo masivo
             ***********************************/
            $scope.modalSendMail = function () {

                var rows = $scope.gridOptionEventStaff.gridApi.selection.getSelectedRows();

                var eventStaffIds = _.chain(rows)
                          .map(function (staff) { return staff.id; })
                          .value();
                if (eventStaffIds.length > 0) {
                    var params = {
                        entity_type: "accreditation_staff",
                        entity_type_id: $stateParams.id,
                        event_staffs_ids: eventStaffIds,
                        mail_account_id: event.mail_account_id,
                        mail_account_reply: event.reply_to,
                        documents: { for_event_staff: true }
                    };
                    notificationService.notificationMail({
                        params: params,
                        onAccept: function (data) {
                            toastr.success($filter('translate')('notifications.sending_mail_success'));
                        }
                    });
                } else {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.staff.select_persons'),
                        onAccept: function () { }
                    });

                }
            }

            $scope.printDialog = function (code, type_document, type_result, id) {
                var rows = $scope.gridOptionEventStaff.gridApi.selection.getSelectedRows();
                var eventStaffIds = _.chain(rows)
                    .map(function (staff) { return staff.id; })
                    .value();
                if (eventStaffIds.length > 0) {
                    var params = {
                        entity_type: "events",
                        entity_type_id: $stateParams.id,
                        documents: { codes: [code] }
                    };
                    generateDocumentService.documentNew({
                        params: params,
                        onAccept: function (data) {
                            angular.forEach(data, function (item) {
                                $http({
                                    method: 'post',
                                    url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                    params: { document_id: item.document_id, entity_type: "events", entity_type_id: $stateParams.id, staff_ids: eventStaffIds.toString(), outputType: 'pdf' }
                                }).then(function (result, status, headers, config) {
                                    var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                    window.open(url, '_blank');
                                });
                            })
                        }
                    });
                } else {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.staff.select_persons'),
                        onAccept: function () { }
                    });
                }
            }
        }])


    .controller("SearchStaffModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'gridService', '$uibModal', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, gridService, $uibModal) {

        $scope.showResults = false;
        $scope.search = {};

        //Custom function.  return null values instead of undefined
        function isDefinedAndNotNull(val) {
            return angular.isDefined(val) && val !== null
        }

        Restangular.all('StaffPositions').getList().then(function (staff_positions) {

            $scope.selectPositions = staff_positions;
        });


        $scope.searchStaffOptions = function () {
            $scope.gridStaffOptionsSelected = [];
            $scope.showResults = true;

            if (angular.isDefined($scope.gridStaffOptions)) {
                $scope.gridStaffOptionsSelected = [];
                $scope.gridStaffOptions.loadData(false);
            } else {
                $scope.gridStaffOptions = {
                    exporterMenuCsv: false,
                    enableGridMenu: true,
                    enableHiding: false,
                    enableSelectionBatchEvent: false,//para obtener los seleccionados
                    //gridMenuShowHideColumns: false,
                    paginationPageSizes: [5, 10, 25],
                    paginationPageSize: 5,
                    onRegisterApi: function (gridApi) {
                        $scope.gridStaffOptions.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableFiltering: false, enableHiding: false },
                      { name: 'puesto', field: 'FK_staff_staff_positions.name', displayName: $filter('translate')('staff.staff_position'), enableFiltering: true },
                      { name: 'name', displayName: $filter('translate')('staff.name'), enableFiltering: false, enableHiding: false },
                      { name: 'surname', displayName: $filter('translate')('staff.surname'), enableFiltering: false },
                      { name: 'lastname', displayName: $filter('translate')('staff.lastname'), enableFiltering: false },
                      { name: 'provider_name', displayName: $filter('translate')('staff.provider_name'), enableFiltering: false },
                      {
                          name: 'is_external', displayName: $filter('translate')('events.staff.is_external'), width: 100,
                          enableFiltering: false, enableHiding: false, cellTemplate: gridService.yesNoTemplate('is_external')
                      }
                    ],
                    getData: function (options) {
                        var deferred = $q.defer();
                        options.event_id = $stateParams.id;
                        options.staff_position_id = $scope.search.staff_position_id;
                        options.name = $scope.search.name;
                        options.surname = $scope.search.surname;
                        options.provider_name = $scope.search.provider_name;
                        if (isDefinedAndNotNull($scope.search.is_external) && $scope.search.is_external != "") {
                            options.is_external = $scope.search.is_external == 1 ? true : false;
                            if (!options.is_external) options.provider_name = null;
                        }

                        options.lastname = $scope.search.lastname;
                        $http({
                            method: 'get',
                            url: (window as any).CONFIG.api_url + 'EventsStaff/SearchStaffOptions',
                            params: options

                        }).then(function (results, status, headers, config) {
                            var data = results.data.rows;
                            data.totalRows = results.data.totalRows;
                            $scope.totalRows = results.data.totalRows;
                            deferred.resolve(data);
                        });
                        return deferred.promise;
                    }
                }; //End gridoptions
            }
        }


        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addStaff = function () {
            //Devolvemos el control al principal
            var rows = $scope.gridStaffOptions.gridApi.selection.getSelectedRows();
            var ids = new Array();
            angular.forEach(rows, function (row) {
                ids.push(row.id);
            });
            if (ids.length > 0) {
                var staffOptions = { event_id: $stateParams.id, eventStaff: ids };
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsStaff/AddStaffToEvent',
                    params: staffOptions

                }).then(function (results, status, headers, config) {
                    //Devolvemos el control al principal
                    $uibModalInstance.close();
                });
            }

        };

        $scope.addNewStaff = function (is_external) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AddNewStaffModalView,
                size: "lg",
                controller: "AddNewStaffModalCtrl",
                resolve: {

                    is_external: function () {
                        return is_external;
                    },
                }
            });
        }


    }])

.controller("AddNewStaffModalCtrl", ['$scope', '$uibModalInstance', 'is_external', function ($scope, $uibModalInstance, is_external) {

    $scope.is_external = is_external;

    $scope.callbackClose = function (mode) {
        $uibModalInstance.dismiss(mode);
    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}])
;
